import {
  BrowserRouter as Router,
} from "react-router-dom";

import Content from "./components/Content";

function App() {
  
  return (
    <Router>
        <Content/>
    </Router>
  );
}

export default App
